var T;(function(T){T[T["TOP"]=1]="TOP";T[T["RIGHT"]=2]="RIGHT";T[T["BOTTOM"]=3]="BOTTOM";T[T["LEFT"]=4]="LEFT"})(T||(T={}));export{T as EIconPopoverPositions};
//# sourceMappingURL=enums.js.map
